function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19 10a9 9 0 10-10.406 8.89v-6.288H6.309V10h2.285V8.017c0-2.255 1.343-3.501 3.4-3.501.984 0 2.014.175 2.014.175v2.215h-1.135c-1.118 0-1.467.694-1.467 1.406V10h2.496l-.399 2.602h-2.097v6.289C15.71 18.215 19 14.492 19 10",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPmljb24vZmFjZWJvb2s8L3RpdGxlPjxwYXRoIGQ9Ik0xOSAxMGE5IDkgMCAxIDAtMTAuNDA2IDguODl2LTYuMjg4SDYuMzA5VjEwaDIuMjg1VjguMDE3YzAtMi4yNTUgMS4zNDMtMy41MDEgMy40LTMuNTAxLjk4NCAwIDIuMDE0LjE3NSAyLjAxNC4xNzV2Mi4yMTVoLTEuMTM1Yy0xLjExOCAwLTEuNDY3LjY5NC0xLjQ2NyAxLjQwNlYxMGgyLjQ5NmwtLjM5OSAyLjYwMmgtMi4wOTd2Ni4yODlDMTUuNzEgMTguMjE1IDE5IDE0LjQ5MiAxOSAxMCIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4K";
export { SvgFacebook as ReactComponent };